var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetmask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 27,
    viewBox: "0 0 142 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.548 13.9639C124.815 13.4806 124.008 13.1369 123.244 12.7073C122.748 12.428 122.22 12.1809 121.79 11.8265C121.057 11.2251 121.208 10.0436 121.973 9.52805C123.071 8.7977 124.891 9.20577 125.085 10.6988C125.085 10.7309 125.117 10.7525 125.149 10.7525H126.808C126.851 10.7525 126.883 10.7203 126.873 10.6773C126.786 9.64617 126.388 8.78693 125.656 8.23915C124.955 7.71285 124.159 7.43359 123.308 7.43359C118.925 7.43359 118.526 12.0628 120.885 13.5236C121.154 13.6954 123.469 14.8554 124.288 15.3602C125.106 15.865 125.365 16.7887 125.009 17.5191C124.686 18.185 123.846 18.6469 123.007 18.5932C122.091 18.5395 121.38 18.0454 121.132 17.2721C121.089 17.1325 121.068 16.8639 121.068 16.7458C121.068 16.7135 121.035 16.6813 121.003 16.6813H119.205C119.173 16.6813 119.141 16.7135 119.141 16.7458C119.141 18.0454 119.464 18.765 120.347 19.4202C121.176 20.0432 122.08 20.301 123.017 20.301C125.473 20.301 126.743 18.9154 127.001 17.4761C127.227 16.0691 126.808 14.8017 125.548 13.9639Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.466 7.66992H46.6692H45.7969C45.7646 7.66992 45.743 7.6914 45.7323 7.71288L44.2571 12.5677C44.2355 12.6322 44.1494 12.6322 44.1278 12.5677L42.6526 7.71288C42.6418 7.68066 42.6202 7.66992 42.5879 7.66992H41.7157H40.9188H39.842C39.8097 7.66992 39.7773 7.70214 39.7773 7.73436V20.1292C39.7773 20.1613 39.8097 20.1936 39.842 20.1936H41.6403C41.6726 20.1936 41.705 20.1613 41.705 20.1292V10.7095C41.705 10.6343 41.8126 10.6236 41.8342 10.6881L43.3202 15.5751L43.4278 15.9188C43.4386 15.951 43.4602 15.9618 43.4925 15.9618H44.8709C44.9031 15.9618 44.9247 15.9402 44.9354 15.9188L45.0431 15.5751L46.5292 10.6881C46.5507 10.6129 46.6584 10.6343 46.6584 10.7095V20.1292C46.6584 20.1613 46.6907 20.1936 46.723 20.1936H48.5213C48.5536 20.1936 48.5859 20.1613 48.5859 20.1292V7.73436C48.5859 7.70214 48.5536 7.66992 48.5213 7.66992H47.466Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0126 7.66992C97.9803 7.66992 97.9587 7.6914 97.948 7.71288L96.4733 12.5677C96.4518 12.6322 96.3656 12.6322 96.344 12.5677L94.8686 7.71288C94.8578 7.68066 94.8363 7.66992 94.8039 7.66992H92.0686C92.0362 7.66992 92.0039 7.70214 92.0039 7.73436V20.1292C92.0039 20.1613 92.0362 20.1936 92.0686 20.1936H93.8673C93.8996 20.1936 93.9319 20.1613 93.9319 20.1292V10.7095C93.9319 10.6343 94.0397 10.6236 94.0612 10.6881L95.5466 15.5751L95.6544 15.9188C95.6652 15.951 95.6867 15.9618 95.719 15.9618H97.0975C97.1298 15.9618 97.1514 15.9402 97.1622 15.9188L97.2699 15.5751L98.7561 10.6881C98.7777 10.6129 98.8854 10.6343 98.8854 10.7095V20.1292C98.8854 20.1613 98.9178 20.1936 98.9501 20.1936H100.748C100.78 20.1936 100.813 20.1613 100.813 20.1292V7.73436C100.813 7.70214 100.78 7.66992 100.748 7.66992H98.0126Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8187 7.66992H71.4697H69.6714H66.3225C66.2901 7.66992 66.2578 7.70214 66.2578 7.73436V9.28099C66.2578 9.31324 66.2901 9.34548 66.3225 9.34548H69.6068V20.1292C69.6068 20.1613 69.6391 20.1936 69.6714 20.1936H71.4697C71.502 20.1936 71.5344 20.1613 71.5344 20.1292V9.34548H74.8187C74.851 9.34548 74.8833 9.31324 74.8833 9.28099V7.73436C74.8833 7.70214 74.8618 7.66992 74.8187 7.66992Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.423 20.1935H87.0593C87.1024 20.1935 87.1347 20.1506 87.1239 20.1077L83.7428 7.66991C83.7321 7.6377 83.7105 7.62695 83.6782 7.62695H83.0538H81.9554H81.3308C81.2985 7.62695 81.2769 7.64844 81.2662 7.66991L77.8849 20.1077C77.8741 20.1506 77.9065 20.1935 77.9496 20.1935H79.5863C79.6186 20.1935 79.6402 20.1721 79.651 20.1506L80.6309 16.531C80.6416 16.4988 80.6631 16.488 80.6955 16.488H84.314C84.3463 16.488 84.3678 16.5095 84.3786 16.531L85.3584 20.1506C85.3691 20.1721 85.4015 20.1935 85.423 20.1935ZM81.1262 14.7158L82.44 9.87173C82.4614 9.80732 82.5476 9.80732 82.5692 9.87173L83.8829 14.7158C83.8937 14.7588 83.8614 14.8017 83.8183 14.8017H81.1908C81.1477 14.8017 81.1155 14.7588 81.1262 14.7158Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M113.337 20.1935H114.973C115.016 20.1935 115.049 20.1506 115.038 20.1077L111.657 7.66991C111.646 7.6377 111.624 7.62695 111.592 7.62695H110.968H109.87H109.245C109.212 7.62695 109.191 7.64844 109.18 7.66991L105.799 20.1077C105.788 20.1506 105.821 20.1935 105.864 20.1935H107.501C107.533 20.1935 107.555 20.1721 107.565 20.1506L108.545 16.531C108.556 16.4988 108.577 16.488 108.61 16.488H112.228C112.26 16.488 112.282 16.5095 112.293 16.531L113.272 20.1506C113.283 20.1721 113.305 20.1935 113.337 20.1935ZM109.04 14.7158L110.354 9.87173C110.375 9.80732 110.462 9.80732 110.483 9.87173L111.797 14.7158C111.808 14.7588 111.775 14.8017 111.732 14.8017H109.105C109.062 14.8017 109.029 14.7588 109.04 14.7158Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8885 18.3569V14.5117C55.8885 14.4796 55.9208 14.4473 55.9531 14.4473H60.745C60.7773 14.4473 60.8097 14.4151 60.8097 14.3828V12.8362C60.8097 12.804 60.7773 12.7718 60.745 12.7718H55.9531C55.9208 12.7718 55.8885 12.7395 55.8885 12.7073V9.42069C55.8885 9.38844 55.9208 9.3562 55.9531 9.3562H61.4019C61.4342 9.3562 61.4666 9.32395 61.4666 9.29179V7.74511C61.4666 7.71289 61.4342 7.68066 61.4019 7.68066H55.8885H54.0256C53.9933 7.68066 53.9609 7.71289 53.9609 7.74511V9.3562V12.7825V14.4581V18.4321V20.1291C53.9609 20.1614 53.9933 20.1936 54.0256 20.1936H55.8885H61.628C61.6604 20.1936 61.6927 20.1614 61.6927 20.1291V18.4966C61.6927 18.4643 61.6604 18.4321 61.628 18.4321H55.9423C55.91 18.4214 55.8885 18.3999 55.8885 18.3569Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M141.98 20.0862L135.756 13.6739C135.734 13.6525 135.734 13.6095 135.756 13.5881L141.356 7.78807C141.399 7.74511 141.367 7.68066 141.313 7.68066H139.019C138.998 7.68066 138.987 7.69141 138.976 7.70215L134.227 12.6214C134.184 12.6643 134.119 12.6321 134.119 12.5784V7.74511C134.119 7.71289 134.087 7.68066 134.055 7.68066H132.256C132.224 7.68066 132.191 7.71289 132.191 7.74511V20.1399C132.191 20.1721 132.224 20.2044 132.256 20.2044H134.055C134.087 20.2044 134.119 20.1721 134.119 20.1399V14.6836C134.119 14.6299 134.195 14.5977 134.227 14.6406L139.611 20.1828C139.622 20.1936 139.643 20.2044 139.654 20.2044H141.948C141.991 20.1936 142.023 20.1184 141.98 20.0862Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4884 1L16.6016 9.05552L18.6261 4.30814L27.4884 1Z",
    fill: "#E17726",
    stroke: "#E17726",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.37891 1L13.1689 9.1307L11.2413 4.30813L2.37891 1Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5686 19.6777L20.6719 24.1029L26.8745 25.8107L28.6513 19.7745L23.5686 19.6777Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1.22656 19.7745L2.99257 25.8107L9.18443 24.1029L6.29847 19.6777L1.22656 19.7745Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85182 12.2026L7.12891 14.8018L13.2669 15.0811L13.0623 8.47559L8.85182 12.2026Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0165 12.2026L16.7416 8.40039L16.6016 15.0811L22.7395 14.8019L21.0165 12.2026Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18359 24.1029L12.8986 22.3092L9.7005 19.8174L9.18359 24.1029Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9688 22.3092L20.673 24.1029L20.1669 19.8174L16.9688 22.3092Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M20.673 24.1032L16.9688 22.3096L17.2702 24.7155L17.2379 25.7358L20.673 24.1032Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18359 24.1032L12.6295 25.7358L12.608 24.7155L12.8986 22.3096L9.18359 24.1032Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6931 18.2282L9.61328 17.3261L11.7885 16.3271L12.6931 18.2282Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1758 18.2282L18.0804 16.3271L20.2663 17.3261L17.1758 18.2282Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18278 24.1029L9.72124 19.6777L6.29688 19.7745L9.18278 24.1029Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1445 19.6777L20.6722 24.1029L23.5689 19.7745L20.1445 19.6777Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7395 14.8018L16.6016 15.081L17.1723 18.2281L18.0768 16.3269L20.2628 17.3258L22.7395 14.8018Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6164 17.3258L11.7916 16.3269L12.6962 18.2281L13.2669 15.081L7.12891 14.8018L9.6164 17.3258Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M7.12891 14.8018L9.70257 19.8177L9.61637 17.3258L7.12891 14.8018Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2649 17.3258L20.168 19.8177L22.7416 14.8018L20.2649 17.3258Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2661 15.0811L12.6953 18.2281L13.4168 21.9444L13.5783 17.0466L13.2661 15.0811Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6023 15.0811L16.3008 17.0359L16.4516 21.9444L17.173 18.2281L16.6023 15.0811Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1746 18.2284L16.4531 21.9446L16.97 22.3099L20.1683 19.818L20.2652 17.3262L17.1746 18.2284Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61328 17.3262L9.69949 19.818L12.8976 22.3099L13.4145 21.9446L12.6931 18.2284L9.61328 17.3262Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2384 25.7361L17.2706 24.7157L16.9907 24.4794H12.8772L12.608 24.7157L12.6295 25.7361L9.18359 24.1035L10.3896 25.0916L12.8341 26.778H17.0229L19.4781 25.0916L20.6734 24.1035L17.2384 25.7361Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9706 22.3095L16.4537 21.9443H13.417L12.9002 22.3095L12.6094 24.7154L12.8786 24.4791H16.9921L17.2721 24.7154L16.9706 22.3095Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9524 9.58179L28.8678 5.13517L27.4894 1L16.9688 8.78704L21.0176 12.2025L26.7356 13.8674L27.9956 12.3959L27.4464 11.9985L28.3186 11.2037L27.651 10.6881L28.5232 10.0222L27.9524 9.58179Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.13517L1.92608 9.58179L1.33382 10.0222L2.21683 10.6881L1.54919 11.2037L2.42143 11.9985L1.87224 12.3959L3.13214 13.8674L8.8502 12.2025L12.8991 8.78704L2.37836 1L1 5.13517Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7367 13.8669L21.0187 12.2021L22.7416 14.8014L20.168 19.8173L23.5708 19.7743H28.6534L26.7367 13.8669Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85055 12.2021L3.13256 13.8669L1.22656 19.7743H6.29847L9.70125 19.8173L7.12764 14.8014L8.85055 12.2021Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6049 15.0815L16.971 8.78743L18.6293 4.30859H11.2422L12.9005 8.78743L13.2666 15.0815L13.4066 17.0578L13.4174 21.9448H16.4541L16.4648 17.0578L16.6049 15.0815Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetmask);
export default __webpack_public_path__ + "static/media/metmask.24607fe0b3f249b4eec55ba805848322.svg";
export { ForwardRef as ReactComponent };